import React,{useEffect} from 'react'
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { kycPostProcess } from '../../../../../../redux/authentication/actionCreator';


function EkycPostProcess(props) {
    
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.auth.loading);
    const referenceId=props.referenceId;
    const action=props.action;
    const REACT_APP_JUMIO_WAIT_TIME = process.env.REACT_APP_JUMIO_WAIT_TIME;

    console.info("EkycPostProcess referenceId : "+referenceId)
    
    useEffect(() => {
      console.info("action : "+action);
      let redirctUrl='/'
      if(action=='signup'){
        redirctUrl='/signup';
      }
        if(!isLoading){
            setTimeout(function() {
            let param={'referenceId':referenceId}
            dispatch(kycPostProcess(param,0,redirctUrl) )
            },REACT_APP_JUMIO_WAIT_TIME)
        }
        
      }, []);
    

    return (
        <Dialog
        open={ true }
        className="error-dialog"
        
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <div className="dialog-content">
          <img className="dialog-icon" alt="icon" src="/images/icon-information.svg"></img>
          <p>Sila tunggu</p>
          <Button variant="contained" className="btn-dialog-loading" disabled={false}>
            <Spin />
          </Button>
        </div>
      </Dialog >
    )
}

export default EkycPostProcess